/*
 * Pipeline Theme — custom Javascript
 */

(function () {
  function openCartDrawer() {
    if (document.body.classList.contains('template-cart')) return;

    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;

    var popdown = document.querySelector('[data-product-add-popdown-wrapper]');
    if (popdown) popdown.classList.remove('is-visible');

    drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }

  // Pipeline fires this after a successful add-to-cart. Open the side drawer
  // instead of the mini popdown notification.
  document.addEventListener(
    'theme:cart:popdown',
    function (event) {
      event.stopImmediatePropagation();

      var opened = false;
      function openOnce() {
        if (opened) return;
        opened = true;
        document.removeEventListener('theme:cart:change', openOnce);
        openCartDrawer();
      }

      document.addEventListener('theme:cart:change', openOnce);
      setTimeout(openOnce, 400);
    },
    true
  );
})();

(function () {
  var REQUEST_PRICE_DOLLARS = 999999;

  function priceOnRequestLabel() {
    return (window.theme && theme.strings && theme.strings.priceOnRequest) || 'Price on request';
  }

  function isPriceOnRequest(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var amount = Number(cents);
    if (!isFinite(amount)) return false;
    return Math.floor(amount / 100) === REQUEST_PRICE_DOLLARS;
  }

  function patchFormatMoney() {
    var currency = window.themeVendor && themeVendor.themeCurrency;
    if (!currency || typeof currency.formatMoney !== 'function' || currency.formatMoney.__wbPatched) return;

    var original = currency.formatMoney.bind(currency);
    currency.formatMoney = function (cents, format) {
      if (isPriceOnRequest(cents)) return priceOnRequestLabel();
      return original(cents, format);
    };
    currency.formatMoney.__wbPatched = true;
  }

  patchFormatMoney();
  document.addEventListener('DOMContentLoaded', patchFormatMoney);
})();

(function () {
  function initProductStickyBar() {
    var bar = document.querySelector('[data-product-sticky-bar]');
    if (!bar) return;

    var sentinel = document.querySelector('[data-product-form] [data-add-action-wrapper]');
    var originalButton = document.querySelector('[data-product-form] [data-add-to-cart]');
    var stickyButton = bar.querySelector('[data-sticky-add-to-cart]');
    var whatsappLink = bar.querySelector('[data-sticky-whatsapp]');
    var visible = false;

    function overlaysOpen() {
      return Boolean(
        document.querySelector('.drawer--visible, .modal.is-open, [data-scroll-locked], .pswp--open')
      );
    }

    function setVisible(next) {
      if (next === visible) return;
      visible = next;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (next) {
        bar.removeAttribute('inert');
      } else {
        bar.setAttribute('inert', '');
      }
      document.documentElement.classList.toggle('has-product-sticky-bar', visible);
      if (visible) {
        document.documentElement.style.setProperty(
          '--product-sticky-bar-height',
          bar.offsetHeight + 'px'
        );
      } else {
        document.documentElement.style.removeProperty('--product-sticky-bar-height');
      }
    }

    function syncFromOriginal() {
      if (!originalButton || !stickyButton) return;

      stickyButton.disabled = originalButton.disabled;
      stickyButton.classList.toggle('loading', originalButton.classList.contains('loading'));
      stickyButton.classList.toggle('has-success', originalButton.classList.contains('has-success'));

      var originalText = originalButton.querySelector('[data-add-to-cart-text]');
      var stickyText = stickyButton.querySelector('.btn-state-ready');
      if (originalText && stickyText) {
        stickyText.textContent = originalText.textContent.trim();
        stickyButton.setAttribute('aria-label', originalText.textContent.trim());
      }
    }

    function update() {
      if (!sentinel) {
        setVisible(false);
        return;
      }

      var rect = sentinel.getBoundingClientRect();
      var inView = rect.bottom > 80 && rect.top < window.innerHeight - 40;
      setVisible(!inView && !overlaysOpen());
    }

    if (whatsappLink) {
      whatsappLink.addEventListener('click', function (event) {
        var dondy = document.getElementById('whatsapp-link');
        if (!dondy) return;
        event.preventDefault();
        dondy.click();
      });
    }

    if (stickyButton && originalButton) {
      stickyButton.addEventListener('click', function () {
        if (originalButton.disabled) return;
        originalButton.click();
      });

      if (window.MutationObserver) {
        new MutationObserver(syncFromOriginal).observe(originalButton, {
          attributes: true,
          attributeFilter: ['disabled', 'class'],
          subtree: true,
          childList: true,
        });
      }
    }

    if (window.IntersectionObserver && sentinel) {
      new IntersectionObserver(update, {
        threshold: 0,
        rootMargin: '-40px 0px -40px 0px',
      }).observe(sentinel);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if (window.MutationObserver) {
      document.querySelectorAll('[data-drawer], [data-modal], body').forEach(function (node) {
        new MutationObserver(update).observe(node, {
          attributes: true,
          attributeFilter: ['class'],
        });
      });
    }

    bar.setAttribute('inert', '');

    syncFromOriginal();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductStickyBar);
  } else {
    initProductStickyBar();
  }
})();

(function () {
  var SALES_FORM_ENDPOINT = 'https://formsubmit.co/ajax/sales@wristboutique.com';

  function displayFieldName(key) {
    var match = /^contact\[([\s\S]*)\]$/.exec(key);
    return match ? match[1] : key;
  }

  function firstNonEmpty(data, keys) {
    for (var i = 0; i < keys.length; i++) {
      var value = data[keys[i]];
      if (Array.isArray(value)) value = value[0];
      if (value && String(value).trim()) return String(value).trim();
    }
    return '';
  }

  function senderName(data) {
    var name = firstNonEmpty(data, ['Name', 'name', 'full_name', 'Full name']);
    if (name) return name;
    var first = firstNonEmpty(data, ['first_name', 'First name', 'First Name']);
    var last = firstNonEmpty(data, ['last_name', 'Last name', 'Last Name']);
    return [first, last].filter(Boolean).join(' ').trim();
  }

  function formPayload(form) {
    var data = {};
    new FormData(form).forEach(function (value, key) {
      if (key === '_honey') return;
      var outKey = displayFieldName(key);
      if (Object.prototype.hasOwnProperty.call(data, outKey)) {
        if (!Array.isArray(data[outKey])) data[outKey] = [data[outKey]];
        data[outKey].push(value);
      } else {
        data[outKey] = value;
      }
    });
    // Box layout keeps labels readable in Podium, which flattens HTML tables.
    data._template = 'box';

    var email = firstNonEmpty(data, ['email', 'Email', '_replyto']);
    if (email) {
      data.email = email;
      data._replyto = email;
    }

    var name = senderName(data);
    if (name) data.name = name;

    return data;
  }

  function isFormSubmitSuccess(body) {
    if (!body) return false;
    if (body.success === true || body.success === 'true') return true;
    var message = String(body.message || '').toLowerCase();
    return message.indexOf('confirm') !== -1 || message.indexOf('activation') !== -1;
  }

  function showSuccess(form) {
    var success = form.querySelector('[data-wb-form-success]');
    var panel = form.querySelector('[data-wb-form-panel]');
    var error = form.querySelector('[data-wb-form-error]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    if (success) success.hidden = false;
    if (panel) panel.hidden = true;
    form.reset();
  }

  function showError(form, message) {
    var error = form.querySelector('[data-wb-form-error]');
    if (!error) return;
    error.hidden = false;
    error.textContent =
      message ||
      'Something went wrong. Please try again or email sales@wristboutique.com.';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute || !form.hasAttribute('data-wb-sales-form')) return;
      if (event.defaultPrevented) return;

      event.preventDefault();

      var honey = form.querySelector('[name="_honey"]');
      if (honey && honey.value) {
        showSuccess(form);
        return;
      }

      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;

      fetch(SALES_FORM_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formPayload(form)),
      })
        .then(function (response) {
          return response.json().then(
            function (body) {
              return { ok: response.ok, body: body };
            },
            function () {
              return { ok: response.ok, body: null };
            }
          );
        })
        .then(function (result) {
          if (isFormSubmitSuccess(result.body)) {
            showSuccess(form);
            return;
          }
          showError(form, result.body && result.body.message);
        })
        .catch(function () {
          showError(form);
        })
        .then(function () {
          if (submit) submit.disabled = false;
        });
    },
    false
  );
})();
